import { AvailableRoundsManager, CurrentGroupSelectionStore, PlayerStatus, Repository, VersionManager, ViewCode } from "shared";
import { ScorecardBinder } from "./ScorecardBinder";
import { getEnvironmentBadge } from "shared";
import { ScorecardAvailableRoundsQuerySource } from "./ScorecardAvailableRoundsQuerySource";
const ACCESS_CODE_STORAGE_KEY = "leaderboardnow.accessCode";
const CURRENT_PLAYER_STORAGE_KEY = "leaderboardnow.currentPlayerId";
const CURRENT_ACCESS_MODE_STORAGE_KEY = "leaderboardnow.accessMode";
let isOpeningRound = false;
let accessCodeControlInitialized = false;
const currentGroupSelectionStore = new CurrentGroupSelectionStore();
function getAppRoot() {
    let root = document.getElementById("app");
    if (!root) {
        root = document.createElement("div");
        root.id = "app";
        document.body.prepend(root);
    }
    return root;
}
function getOrCreateChildElement(id) {
    const existing = document.getElementById(id);
    if (existing)
        return existing;
    const el = document.createElement("div");
    el.id = id;
    getAppRoot().appendChild(el);
    return el;
}
function getLaunchStateContainer() {
    return getOrCreateChildElement("launchStateContainer");
}
function getScorecardContainer() {
    return getOrCreateChildElement("scorecardContainer");
}
function setAccessCodePanelVisible(isVisible) {
    const panel = document.getElementById("accessCodePanel");
    if (panel)
        panel.hidden = !isVisible;
}
function showLaunchState(html) {
    const launchStateContainer = getLaunchStateContainer();
    const scorecardContainer = getScorecardContainer();
    launchStateContainer.innerHTML = html;
    scorecardContainer.hidden = true;
}
function clearLaunchState() {
    getLaunchStateContainer().innerHTML = "";
}
async function openRound(repo, cardId) {
    const normalizedCardId = cardId.trim();
    if (!normalizedCardId) {
        throw new Error("Cannot open scorecard because the scorecard id is blank.");
    }
    if (isOpeningRound)
        return;
    isOpeningRound = true;
    try {
        clearLaunchState();
        setAccessCodePanelVisible(false);
        getScorecardContainer().hidden = false;
        await ScorecardBinder.create(repo, normalizedCardId);
    }
    finally {
        isOpeningRound = false;
    }
}
function showLaunchErrorMessage(error) {
    showLaunchState(`
    <div style="
      position: relative;
      max-width: 700px;
      margin: 40px auto;
      padding: 24px;
      font-family: Arial, sans-serif;
      text-align: center;
    ">
      <h2>Unable to load scorecard</h2>
      <p style="color: #b91c1c;">
        ${escapeHtml(getErrorMessage(error))}
      </p>
    </div>
  `);
}
function getErrorMessage(error) {
    if (error instanceof Error && error.message) {
        return error.message;
    }
    return String(error ?? "Unknown error");
}
function escapeHtml(value) {
    return String(value)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
}
function getRequestedCardId() {
    const params = new URLSearchParams(window.location.search);
    return {
        cardId: params.get("cardId") ?? params.get("cardid"),
    };
}
async function createRepository() {
    return Repository.create();
}
async function openRequestedScorecard(repo, cardId) {
    await openRound(repo, cardId);
}
function ensureAccessCodePanelExists() {
    if (document.getElementById("accessCodeInput"))
        return;
    showLaunchState(`
    <div
      style="
        max-width: 700px;
        margin: 40px auto;
        padding: 24px;
        font-family: Arial, sans-serif;
        text-align: center;
      "
    >
      <div id="recentRoundsPanel" class="recent-rounds-panel">
        <h3>Available Rounds</h3>
        <div id="recentRoundsList"></div>
      </div>

      <h2>Enter round access code</h2>
      <p>Enter the code for the round you want to view.</p>

      <input
        id="accessCodeInput"
        type="text"
        autocomplete="off"
        autocapitalize="characters"
        spellcheck="false"
        style="font-size: 20px; padding: 8px; text-transform: uppercase;"
      />

      <button
        id="accessCodeSubmitBtn"
        type="button"
        style="font-size: 20px; padding: 8px 14px;"
      >
        Continue
      </button>

      <button
        id="homeMenuBtn"
        type="button"
        aria-expanded="false"
        aria-controls="homeMenuPanel"
        style="
          position: absolute;
          top: 14px;
          right: 14px;
          font-size: 22px;
          line-height: 1;
          padding: 6px 10px;
          background: transparent;
          border: 1px solid #ccc;
          border-radius: 6px;
          cursor: pointer;
        "
      >
        ☰
      </button>

      <div
        id="homeMenuPanel"
        hidden
        style="
          position: absolute;
          top: 50px;
          right: 14px;
          min-width: 180px;
          padding: 10px;
          background: white;
          border: 1px solid #ccc;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          text-align: left;
          z-index: 10;
        "
      >
        <button
          id="homeReloadAppBtn"
          type="button"
          style="
            width: 100%;
            font-size: 16px;
            padding: 8px 10px;
            text-align: left;
            background: none;
            border: none;
            cursor: pointer;
          "
        >
          ↻ Reload App
        </button>

        <button
          id="updateProfileBtn"
          type="button"
          style="
            width: 100%;
            font-size: 16px;
            padding: 8px 10px;
            text-align: left;
            background: none;
            border: none;
            cursor: pointer;
          "
        >
          Update Profile
        </button>

        <button
          id="homeCaptainToolsBtn"
          type="button"
          style="
            width: 100%;
            font-size: 16px;
            padding: 8px 10px;
            text-align: left;
            background: none;
            border: none;
            cursor: pointer;
          "
        >
          Captain Tools
        </button>
      </div>

      <div id="accessCodeStatus" style="margin-top: 14px;"></div>

      <details
        style="
          margin-top: 24px;
          text-align: left;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 12px;
        "
      >
        <summary
          style="
            cursor: pointer;
            font-weight: bold;
            text-align: center;
          "
        >
          First time setup?
        </summary>
<div style="margin-top: 12px;">
  <ol>
    <li>Tap the Share button in Safari. (the square with an arrow pointing up)</li>
    <li>
      Scroll down to and select <strong>Add to Home Screen</strong>.
      Don't forget to click Add at the top of the screen.
    </li>
    <li>Close this browser and click the green LeaderboardNow icon on your phone's Home Screen.</li>

    <li>
      <hr>
      If you were given a temporary nickname such as
      <strong>P1</strong> or <strong>P2</strong>, open the menu (☰) in the top right corner of this page, and
      select <strong>Update Profile</strong>, enter the temporary nickname,
      and complete your profile. Be sure to replace the temporary nickname
      with a unique nickname of your choice. This will be used to update your profile, especially your handicap in the future. Also select a unique initial as a display code for your scores.
    </li>
    <hr>
    <li>Prior to each round, you will receive a round access code that you will enter above to join the round.</li>
    <li>Check in as your player (the Display Code on your profile).</li>
  </ol>
</div>
      </details>
    </div>

    <div id="updateProfileDialog" class="modal" hidden>
      <div class="modal-content">
        <h3>Update Profile</h3>

        <div class="form-field">
          <label for="memberNickNameLookup">Nickname</label>
          <input
            id="memberNickNameLookup"
            type="text"
            autocomplete="nickname"
            placeholder="Example: JimC"
          />
        </div>

        <button id="loadProfileBtn" type="button">
          Load Profile
        </button>

        <hr />

        <div id="profileFields" hidden>
          <div class="form-field">
            <label for="profileName">Full Name</label>
            <input id="profileName" type="text" />
          </div>

          <div class="profile-row">
            <div>
              <label for="profileInitial">Display Code</label>
              <input
                id="profileInitial"
                type="text"
                maxlength="1"
                class="initial-input"
              />
            </div>

            <div>
              <label for="profileHdcp">Handicap</label>
              <input
                id="profileHdcp"
                type="number"
                step="0.1"
              />
            </div>
          </div>

          <div class="form-field">
            <label for="profileEmail">Email</label>
            <input
              id="profileEmail"
              type="email"
            />
          </div>

          <div class="form-field">
            <label for="profilePhone">Phone</label>
            <input
              id="profilePhone"
              type="tel"
            />
          </div>

          <div class="profile-actions">
            <button
              id="saveProfileBtn"
              type="button"
            >
              Save Profile
            </button>
          </div>
        </div>

        <div class="profile-actions">
          <button
            id="cancelProfileBtn"
            type="button"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  `);
}
function getAccessCodeInput() {
    return document.getElementById("accessCodeInput");
}
function getAccessCodeStatus() {
    return document.getElementById("accessCodeStatus");
}
function getAccessCodeButtons() {
    const ids = [
        "accessCodeSubmitBtn",
        "accessCodeButton",
        "accessCodeSubmit",
        "accessCodeContinueButton",
        "continueAccessCodeButton",
    ];
    return ids
        .map((id) => document.getElementById(id))
        .filter((button) => !!button);
}
function setAccessCodeStatus(message) {
    const status = getAccessCodeStatus();
    if (status)
        status.textContent = message;
}
function normalizeInitial(initial) {
    return String(initial ?? "").trim().toUpperCase();
}
function getCurrentPlayerId() {
    const value = String(localStorage.getItem(CURRENT_PLAYER_STORAGE_KEY) ?? "").trim();
    return value || null;
}
function disconnectCurrentPlayer() {
    localStorage.removeItem(CURRENT_PLAYER_STORAGE_KEY);
    localStorage.removeItem(CURRENT_ACCESS_MODE_STORAGE_KEY);
    localStorage.removeItem(ACCESS_CODE_STORAGE_KEY);
}
function setCurrentRoundIdentity(accessMode, playerId) {
    localStorage.setItem(CURRENT_ACCESS_MODE_STORAGE_KEY, accessMode);
    if (accessMode === "player" && playerId) {
        localStorage.setItem(CURRENT_PLAYER_STORAGE_KEY, String(playerId).trim());
    }
    else if (accessMode === "gallery") {
        localStorage.removeItem(CURRENT_PLAYER_STORAGE_KEY);
    }
}
function saveStoredAccessCode(accessCode) {
    localStorage.setItem(ACCESS_CODE_STORAGE_KEY, ViewCode.normalize(accessCode));
}
function clearStoredRoundSession() {
    localStorage.removeItem(ACCESS_CODE_STORAGE_KEY);
    localStorage.removeItem(CURRENT_ACCESS_MODE_STORAGE_KEY);
}
function getPlayerStatuses(scorecard) {
    const existing = Array.isArray(scorecard.playerStatuses)
        ? scorecard.playerStatuses
        : [];
    return (scorecard.players ?? []).map((player) => {
        const memberId = String(player.memberId ?? '').trim();
        const displayCode = normalizeInitial(player.displayCode ?? player.displayCode);
        const found = existing.find((status) => String(status.memberId ?? '').trim() === memberId);
        const status = PlayerStatus.from(found?.status);
        return {
            memberId,
            displayCode,
            status: status.toFirestoreValue(),
            checkedInBy: status.value === 'self'
                ? memberId
                : String(found?.checkedInBy ?? '').trim(),
        };
    });
}
function allPlayersCheckedIn(scorecard) {
    return getPlayerStatuses(scorecard).every((player) => PlayerStatus.from(player.status).value !== "none");
}
async function savePlayerStatuses(repo, scorecard, playerStatuses) {
    const updated = {
        ...scorecard,
        playerStatuses,
    };
    await repo.ScoreCards.update(updated);
    const reloaded = await repo.ScoreCards.get(scorecard.id);
    return reloaded ?? updated;
}
async function claimPlayerSelf(repo, scorecard, memberId) {
    const targetMemberId = String(memberId ?? '').trim();
    const playerStatuses = getPlayerStatuses(scorecard);
    const target = playerStatuses.find((player) => player.memberId === targetMemberId);
    if (!target) {
        throw new Error('Player is not in this round.');
    }
    const updatedStatuses = playerStatuses.map((player) => {
        if (player.memberId !== targetMemberId)
            return player;
        return {
            ...player,
            status: PlayerStatus.self().toFirestoreValue(),
            checkedInBy: targetMemberId,
        };
    });
    return savePlayerStatuses(repo, scorecard, updatedStatuses);
}
async function renderPlayerClaimPanel(repo, scorecard, acceptedAccessCode) {
    const group = await repo.Groups.get(scorecard.group);
    const statuses = getPlayerStatuses(scorecard);
    const buttons = statuses.map((player) => {
        const playerStatus = PlayerStatus.from(player.status);
        const member = group?.members?.find((m) => String(m.id ?? '').trim() === player.memberId);
        const name = String(member?.name ?? member?.nickName ?? '').trim() ||
            player.displayCode;
        const baseLabel = `${name} [${player.displayCode}]`;
        const label = playerStatus.value === 'withdrawn' ? `${baseLabel} (withdrawn)`
            : playerStatus.value === 'proxy' ? `${baseLabel} (checked in - no phone)`
                : playerStatus.value === 'self' ? `${baseLabel} (checked in - has phone)`
                    : baseLabel;
        return `
      <button
        class="player-claim-button"
        data-member-id="${escapeHtml(player.memberId)}"
        data-display-value="${escapeHtml(player.displayCode)}"
        style="font-size:18px;padding:8px 14px;margin:6px;"
      >
        ${escapeHtml(label)}
      </button>
    `;
    }).join('');
    showLaunchState(`
  <div style="max-width:700px;margin:40px auto;padding:24px;font-family:Arial,sans-serif;text-align:center;">
    <h2>Check in as player</h2>
    <p>Select your player.</p>

    <div class="player-button-container">
      ${buttons}
    </div>

    <div id="playerClaimStatus" style="margin-top:14px;"></div>

    <button
      id="cancelPlayerClaimBtn"
      type="button"
      style="
        font-size: 16px;
        padding: 8px 14px;
        margin-top: 18px;
      "
    >
      Cancel
    </button>
  </div>
`);
    document.querySelectorAll(".player-claim-button").forEach((button) => {
        button.addEventListener("click", async () => {
            const memberId = String(button.dataset.memberId ?? '').trim();
            const displayCode = normalizeInitial(button.dataset.displayValue);
            const status = document.getElementById("playerClaimStatus");
            try {
                if (status) {
                    status.textContent = `Checking in as ${displayCode}...`;
                }
                setCurrentRoundIdentity("player", memberId);
                if (!isRoundScheduledForToday(scorecard.date)) {
                    clearStoredRoundSession();
                    initializeAccessCodeLaunch(repo);
                    setAccessCodeStatus(`Connected as player ${displayCode}. ` +
                        `This round cannot be opened until ${formatRoundDay(scorecard.date)}.`);
                    return;
                }
                const updated = await claimPlayerSelf(repo, scorecard, memberId);
                saveStoredAccessCode(acceptedAccessCode);
                await openRound(repo, updated.id);
            }
            catch (error) {
                if (status)
                    status.textContent = getErrorMessage(error);
            }
        });
    });
    const cancelButton = document.getElementById("cancelPlayerClaimBtn");
    cancelButton?.addEventListener("click", () => {
        initializeAccessCodeLaunch(repo);
    });
}
async function continueAfterAccessLookup(repo, scorecard, parsed) {
    if (parsed.accessMode === "gallery") {
        if (!allPlayersCheckedIn(scorecard)) {
            setAccessCodeStatus("Gallery access opens after all players are checked in.");
            return false;
        }
        setCurrentRoundIdentity("gallery", null);
        await openRound(repo, scorecard.id);
        return true;
    }
    const currentPlayerId = getCurrentPlayerId();
    const statuses = getPlayerStatuses(scorecard);
    if (currentPlayerId) {
        const current = statuses.find((player) => player.memberId === currentPlayerId);
        if (PlayerStatus.from(current?.status).value === "self") {
            setCurrentRoundIdentity("player", currentPlayerId);
            await openRound(repo, scorecard.id);
            return true;
        }
    }
    await renderPlayerClaimPanel(repo, scorecard, parsed.normalizedInput);
    return true;
}
async function handleAccessCodeEntered(repo, options = {}) {
    const input = getAccessCodeInput();
    if (!input) {
        throw new Error("Access code input #accessCodeInput not found in HTML");
    }
    const enteredCode = ViewCode.normalize(input.value);
    if (!enteredCode) {
        clearStoredRoundSession();
        setAccessCodeStatus(options.fromSavedCode ? "" : "Enter a round access code.");
        return;
    }
    const parsed = ViewCode.parseViewCode(enteredCode);
    if (!parsed) {
        clearStoredRoundSession();
        if (options.fromSavedCode) {
            input.value = "";
            setAccessCodeStatus("");
        }
        else {
            setAccessCodeStatus("Invalid round code.");
        }
        return;
    }
    setAccessCodeStatus(`Looking up ${parsed.viewCode.toUpperCase()}...`);
    const scorecard = (await repo.ScoreCards.findActiveByViewCode(parsed.viewCode));
    if (!scorecard?.id) {
        clearStoredRoundSession();
        if (options.fromSavedCode) {
            input.value = "";
            setAccessCodeStatus("");
        }
        else {
            setAccessCodeStatus(`A scorecard was not found with access code ${ViewCode.normalize(enteredCode)}.`);
        }
        return;
    }
    const roundAccess = ViewCode.validateForRound(enteredCode, scorecard.playerAccessCode ?? scorecard.viewCode);
    if (!roundAccess.isValidForRound) {
        clearStoredRoundSession();
        if (options.fromSavedCode) {
            input.value = "";
            setAccessCodeStatus("");
        }
        else {
            setAccessCodeStatus(`A scorecard was not found with access code ${roundAccess.normalizedInput}.`);
        }
        return;
    }
    setAccessCodeStatus(`Opening ${roundAccess.viewCode.toUpperCase()}...`);
    const accessOpenedOrAccepted = await continueAfterAccessLookup(repo, scorecard, roundAccess);
    if (accessOpenedOrAccepted) {
        saveStoredAccessCode(roundAccess.normalizedInput);
        currentGroupSelectionStore.set(scorecard.group);
    }
    else {
        clearStoredRoundSession();
    }
}
function initializeAccessCodeLaunch(repo) {
    ensureAccessCodePanelExists();
    setAccessCodePanelVisible(true);
    const input = getAccessCodeInput();
    if (!input) {
        throw new Error("Access code input #accessCodeInput not found in HTML");
    }
    getScorecardContainer().hidden = true;
    void populateRecentRoundsList(repo).catch((error) => {
        console.error("[Recent Rounds] failed:", error);
    });
    if (accessCodeControlInitialized)
        return;
    accessCodeControlInitialized = true;
    const savedCode = localStorage.getItem(ACCESS_CODE_STORAGE_KEY) ?? "";
    input.value = savedCode.toUpperCase();
    const openFromInput = () => {
        void handleAccessCodeEntered(repo).catch((error) => {
            console.error("[Scorecard accessCode] failed:", error);
            setAccessCodeStatus(getErrorMessage(error));
        });
    };
    input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            openFromInput();
        }
    });
    input.addEventListener("change", openFromInput);
    input.addEventListener("input", () => {
        setAccessCodeStatus("");
        input.value = input.value.toUpperCase();
    });
    for (const button of getAccessCodeButtons()) {
        button.addEventListener("click", openFromInput);
    }
    const homeMenuBtn = document.getElementById("homeMenuBtn");
    const homeMenuPanel = document.getElementById("homeMenuPanel");
    const homeCaptainToolsBtn = document.getElementById("homeCaptainToolsBtn");
    const homeReloadAppBtn = document.getElementById("homeReloadAppBtn");
    const updateProfileBtn = document.getElementById("updateProfileBtn");
    const updateProfileDialog = document.getElementById("updateProfileDialog");
    const cancelProfileBtn = document.getElementById("cancelProfileBtn");
    const loadProfileBtn = document.getElementById("loadProfileBtn");
    const saveProfileBtn = document.getElementById("saveProfileBtn");
    const memberNickNameLookupInput = document.getElementById("memberNickNameLookup");
    const profileFields = document.getElementById("profileFields");
    const profileName = document.getElementById("profileName");
    const profileInitial = document.getElementById("profileInitial");
    const profileHdcp = document.getElementById("profileHdcp");
    const profileEmail = document.getElementById("profileEmail");
    const profilePhone = document.getElementById("profilePhone");
    let loadedProfileNickName = "";
    if (loadProfileBtn && memberNickNameLookupInput && profileFields) {
        loadProfileBtn.addEventListener("click", async () => {
            const nickName = memberNickNameLookupInput.value.trim();
            if (!nickName) {
                alert("Enter your nickname.");
                return;
            }
            try {
                loadProfileBtn.disabled = true;
                loadProfileBtn.textContent = "Loading...";
                const found = await repo.Groups.findMemberByNickname(nickName);
                if (!found) {
                    profileFields.hidden = true;
                    alert("No member was found for that nickname.");
                    return;
                }
                const member = found.member;
                if (profileName)
                    profileName.value = member.name ?? "";
                loadedProfileNickName = member.nickName ?? nickName;
                if (profileInitial)
                    profileInitial.value = member.initial ?? "";
                if (profileHdcp)
                    profileHdcp.value = String(member.hdcp ?? 0);
                if (profileEmail)
                    profileEmail.value = member.email ?? "";
                if (profilePhone)
                    profilePhone.value = member.phone ?? "";
                profileFields.hidden = false;
            }
            catch (error) {
                console.error("[Profile] load failed:", error);
                alert(getErrorMessage(error));
            }
            finally {
                loadProfileBtn.disabled = false;
                loadProfileBtn.textContent = "Load Profile";
            }
        });
    }
    // Save profile handler
    if (saveProfileBtn && memberNickNameLookupInput) {
        saveProfileBtn.addEventListener("click", async () => {
            const lookupNickName = loadedProfileNickName;
            const updatedNickName = memberNickNameLookupInput.value.trim();
            if (!lookupNickName) {
                alert("Load your profile by nickname before saving.");
                return;
            }
            if (!updatedNickName) {
                alert("Nickname is required.");
                return;
            }
            if (!updatedNickName) {
                alert("Nickname is required.");
                return;
            }
            try {
                saveProfileBtn.disabled = true;
                saveProfileBtn.textContent = "Saving...";
                await repo.Groups.updateMemberProfileByNickName(lookupNickName, {
                    name: profileName?.value.trim() ?? "",
                    nickName: updatedNickName,
                    initial: profileInitial?.value.trim().toUpperCase() ?? "",
                    hdcp: Number(profileHdcp?.value ?? 0),
                    email: profileEmail?.value.trim() ?? "",
                    phone: profilePhone?.value.trim() ?? "",
                });
                loadedProfileNickName = updatedNickName;
                alert("Profile saved.");
                if (updateProfileDialog) {
                    updateProfileDialog.hidden = true;
                }
            }
            catch (error) {
                console.error("[Profile] save failed:", error);
                alert(getErrorMessage(error));
            }
            finally {
                saveProfileBtn.disabled = false;
                saveProfileBtn.textContent = "Save Profile";
            }
        });
    }
    if (homeMenuBtn && homeMenuPanel) {
        homeMenuBtn.addEventListener("click", () => {
            const shouldOpen = homeMenuPanel.hidden;
            homeMenuPanel.hidden = !shouldOpen;
            homeMenuBtn.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
        });
    }
    if (homeReloadAppBtn) {
        homeReloadAppBtn.addEventListener("click", () => {
            void VersionManager.reloadAppFresh();
        });
    }
    if (homeCaptainToolsBtn) {
        homeCaptainToolsBtn.addEventListener("click", () => {
            window.location.href = "/RoundSetup/";
        });
    }
    if (updateProfileBtn && updateProfileDialog) {
        updateProfileBtn.addEventListener("click", () => {
            loadedProfileNickName = "";
            if (memberNickNameLookupInput)
                memberNickNameLookupInput.value = "";
            if (profileFields)
                profileFields.hidden = true;
            updateProfileDialog.hidden = false;
            if (homeMenuPanel) {
                homeMenuPanel.hidden = true;
                homeMenuBtn?.setAttribute("aria-expanded", "false");
            }
        });
    }
    if (cancelProfileBtn && updateProfileDialog) {
        cancelProfileBtn.addEventListener("click", () => {
            loadedProfileNickName = "";
            updateProfileDialog.hidden = true;
        });
    }
    if (savedCode.trim()) {
        void handleAccessCodeEntered(repo, { fromSavedCode: true }).catch((error) => {
            console.error("[Scorecard saved accessCode] failed:", error);
            clearStoredRoundSession();
            input.value = "";
            setAccessCodeStatus("");
        });
    }
}
async function onReady() {
    const badgeContainer = document.getElementById("environment-badge");
    if (badgeContainer) {
        const badge = getEnvironmentBadge();
        if (badge) {
            badgeContainer.className = badge.className;
            badgeContainer.textContent = badge.textContent;
        }
        else {
            badgeContainer.remove();
        }
    }
    try {
        const repo = await createRepository();
        const requestedCardId = getRequestedCardId();
        if (requestedCardId.cardId) {
            await openRequestedScorecard(repo, requestedCardId.cardId);
            return;
        }
        initializeAccessCodeLaunch(repo);
    }
    catch (error) {
        console.error("[index] launch failed:", error);
        showLaunchErrorMessage(error);
    }
}
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        void onReady();
    }, { once: true });
}
else {
    void onReady();
}
async function populateRecentRoundsList(repo) {
    const listDiv = document.getElementById("recentRoundsList");
    if (!listDiv)
        return;
    listDiv.innerHTML = "";
    const currentPlayerId = getCurrentPlayerId();
    if (!currentPlayerId) {
        listDiv.innerHTML = `
    <div style="
      color: #666;
      padding: 10px 0;
    ">
      This device is not connected to a player.<br />
      Enter a valid player access code on the day of a round to connect.
    </div>
  `;
        return;
    }
    async function getCurrentPlayerInitial(currentPlayerId, selectedGroupId) {
        const normalizedGroupId = String(selectedGroupId ?? "").trim();
        if (!normalizedGroupId) {
            return "";
        }
        const group = await repo.Groups.get(normalizedGroupId);
        const member = group?.members?.find((m) => String(m.id ?? "").trim().toUpperCase() ===
            currentPlayerId.trim().toUpperCase());
        return member
            ? String(member.initial ?? "").trim().toUpperCase()
            : "";
    }
    const manager = new AvailableRoundsManager(new ScorecardAvailableRoundsQuerySource(repo.ScoreCards), currentGroupSelectionStore, {
        participantIdsField: "ParticipantIds",
        availableStatuses: [
            "empty",
            "in-progress",
        ],
    });
    let state = await manager.loadForParticipant(currentPlayerId);
    if (state.selectedRounds.length === 0) {
        listDiv.innerHTML =
            "<div style='color:#666'>No available rounds found for the connected player.</div>";
        return;
    }
    const controlsDiv = document.createElement("div");
    controlsDiv.style.cssText = `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;
    let currentPlayerInitial = await getCurrentPlayerInitial(currentPlayerId, state.selectedGroupId);
    const identityText = document.createElement("div");
    identityText.style.cssText = `
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
`;
    const identityLabel = document.createElement("span");
    identityLabel.textContent = currentPlayerInitial
        ? `Connected player: ${currentPlayerInitial}`
        : "No connected player";
    identityText.appendChild(identityLabel);
    if (currentPlayerInitial) {
        const disconnectButton = document.createElement("button");
        disconnectButton.type = "button";
        disconnectButton.textContent = "Disconnect";
        disconnectButton.style.cssText = `
    padding: 0;
    border: none;
    background: none;
    color: #b91c1c;
    text-decoration: underline;
    cursor: pointer;
    font-size: 13px;
  `;
        disconnectButton.addEventListener("click", () => {
            const confirmed = window.confirm(`Are you sure you want to disconnect as player ${currentPlayerInitial}?\n\n` +
                `You will need a valid player access code to connect as a player again.`);
            if (!confirmed)
                return;
            disconnectCurrentPlayer();
            initializeAccessCodeLaunch(repo);
            setAccessCodeStatus("This device is no longer connected to a player. " +
                "Enter a valid player access code to connect again.");
        });
        identityText.appendChild(disconnectButton);
    }
    controlsDiv.appendChild(identityText);
    if (state.requiresGroupSelection) {
        const groupSelect = document.createElement("select");
        groupSelect.setAttribute("aria-label", "Available rounds group");
        groupSelect.style.cssText = `
      max-width: 220px;
      padding: 6px 8px;
      font-size: 14px;
    `;
        for (const availableGroup of state.groups) {
            const option = document.createElement("option");
            option.value = availableGroup.groupId;
            const group = await repo.Groups.get(availableGroup.groupId);
            option.textContent =
                String(group?.name ?? "").trim() ||
                    availableGroup.groupId;
            option.selected =
                availableGroup.groupId ===
                    state.selectedGroupId;
            groupSelect.appendChild(option);
        }
        groupSelect.addEventListener("change", () => {
            state = manager.selectGroup(state, groupSelect.value);
            void (async () => {
                currentPlayerInitial =
                    await getCurrentPlayerInitial(currentPlayerId, state.selectedGroupId);
                identityLabel.textContent =
                    currentPlayerInitial
                        ? `Connected player: ${currentPlayerInitial}`
                        : "No connected player";
                await renderRounds();
            })().catch(error => {
                console.error("[Available Rounds] group render failed:", error);
            });
        });
        controlsDiv.appendChild(groupSelect);
    }
    listDiv.appendChild(controlsDiv);
    const roundsContainer = document.createElement("div");
    listDiv.appendChild(roundsContainer);
    const groupNameCache = new Map();
    const courseNameCache = new Map();
    async function renderRounds() {
        roundsContainer.innerHTML = "";
        const rounds = state.selectedRounds;
        if (rounds.length === 0) {
            roundsContainer.innerHTML = `
      <div style="color:#666;padding:10px 0;">
        No rounds were found for the connected player.
      </div>
    `;
            return;
        }
        const hasRoundsBeyondBookingWindow = rounds.some(sc => !isWithinTwoWeekWindow(sc.date));
        const windowStatus = document.createElement("div");
        windowStatus.style.cssText = `
    margin-bottom: 10px;
    padding: 8px;
    border-radius: 6px;
    font-weight: bold;
  `;
        if (hasRoundsBeyondBookingWindow) {
            windowStatus.textContent =
                "Future tee times are booked beyond the 16-day window.";
            windowStatus.style.background = "#dcfce7";
        }
        else {
            windowStatus.textContent =
                "No tee times are currently booked beyond the 16-day window.";
            windowStatus.style.background = "#fef3c7";
        }
        roundsContainer.appendChild(windowStatus);
        for (const sc of rounds) {
            const dateState = getRoundDateState(sc.date);
            const isToday = dateState === "today";
            const button = document.createElement("button");
            button.type = "button";
            const withinBookingWindow = isWithinTwoWeekWindow(sc.date);
            button.style.cssText = `
      display: block;
      width: 100%;
      text-align: left;
      margin: 6px 0;
      padding: 10px;
      border-radius: 6px;
      background: ${withinBookingWindow
                ? "#dcfce7"
                : "white"};
      cursor: ${isToday ? "pointer" : "default"};
      opacity: ${isToday ? "1" : "0.75"};
    `;
            let groupName = groupNameCache.get(sc.group);
            if (!groupName) {
                const group = await repo.Groups.get(sc.group);
                groupName = group?.name ?? "";
                groupNameCache.set(sc.group, groupName);
            }
            let courseName = courseNameCache.get(sc.courseId);
            if (!courseName) {
                const course = await repo.Courses.get(sc.courseId);
                courseName = course?.name ?? "";
                courseNameCache.set(sc.courseId, courseName);
            }
            const players = (sc.players ?? [])
                .map((player) => String(player.displayCode ?? "").trim())
                .filter(Boolean)
                .join(" • ");
            const accessCode = sc.playerAccessCode ??
                sc.viewCode ??
                "";
            const roundStatusText = dateState === "today"
                ? String(sc.status ?? "empty")
                : dateState === "future"
                    ? "Scheduled — check-in available on day of round"
                    : dateState === "past"
                        ? "Past round"
                        : "Invalid round date";
            button.innerHTML = `
      <div style="
        display:flex;
        justify-content:space-between;
        align-items:center;
        gap:8px;
      ">
        <div style="font-size:16px;font-weight:bold;">
          ${formatRoundDate(sc.date)}
        </div>

      </div>

      <div style="margin-top:3px;">
        <strong>${escapeHtml(courseName)}</strong>
        ${groupName
                ? " — " + escapeHtml(groupName)
                : ""}
      </div>

      <div style="margin-top:4px;">
        <strong>Access:</strong>
        ${escapeHtml(accessCode)}
      </div>

      <div style="margin-top:4px;">
        <strong>Players:</strong>
        ${escapeHtml(players)}
      </div>

      <div style="margin-top:2px;color:#666;">
        ${escapeHtml(roundStatusText)}
      </div>
    `;
            button.addEventListener("click", async () => {
                if (!isToday)
                    return;
                const roundAccess = ViewCode.validateForRound(sc.playerAccessCode ?? sc.viewCode, sc.playerAccessCode ?? sc.viewCode);
                if (!roundAccess.isValidForRound) {
                    alert("This scorecard does not have a valid access code.");
                    return;
                }
                const opened = await continueAfterAccessLookup(repo, sc, roundAccess);
                if (opened) {
                    saveStoredAccessCode(roundAccess.normalizedInput);
                    currentGroupSelectionStore.set(sc.group);
                }
            });
            roundsContainer.appendChild(button);
        }
    }
    await renderRounds();
}
function isWithinTwoWeekWindow(dateValue) {
    const teeTime = new Date(String(dateValue ?? ""));
    if (Number.isNaN(teeTime.getTime()))
        return false;
    const now = new Date();
    const twoWeeksFromNow = new Date(now);
    twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 16);
    return teeTime >= now && teeTime <= twoWeeksFromNow;
}
function formatRoundDate(value) {
    const raw = String(value ?? "").trim();
    if (!raw)
        return "No date";
    const date = new Date(raw);
    if (Number.isNaN(date.getTime()))
        return raw;
    return date.toLocaleString([], {
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}
function getRoundDateState(dateValue) {
    const teeTime = new Date(String(dateValue ?? ""));
    if (Number.isNaN(teeTime.getTime())) {
        return "invalid";
    }
    const roundDay = new Date(teeTime.getFullYear(), teeTime.getMonth(), teeTime.getDate());
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (roundDay.getTime() < today.getTime()) {
        return "past";
    }
    if (roundDay.getTime() > today.getTime()) {
        return "future";
    }
    return "today";
}
function isRoundScheduledForToday(dateValue) {
    const teeTime = new Date(String(dateValue ?? ""));
    if (Number.isNaN(teeTime.getTime()))
        return false;
    const today = new Date();
    return (teeTime.getFullYear() === today.getFullYear() &&
        teeTime.getMonth() === today.getMonth() &&
        teeTime.getDate() === today.getDate());
}
function formatRoundDay(value) {
    const date = new Date(String(value ?? ""));
    if (Number.isNaN(date.getTime())) {
        return "another date";
    }
    return date.toLocaleDateString([], {
        weekday: "long",
        month: "long",
        day: "numeric",
    });
}
//# sourceMappingURL=index.js.map